import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import contactimg from '../../assets/images/contact-img.png'
import { fynitoApi } from '../Services/axios'
import toastify from '../../helper/toastify'
import { useSelector } from 'react-redux'
import MobileBottomBar from '../Layout/MobileBottomBar';

const ContactUs = () => {
    const { commonwebData } = useSelector(state => state.auth);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: ""
    })
    const [loading, setLoading] = useState(false);



      // Scroll to top is now handled globally in Layout component

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    // Handle Contact Api
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            const res = await fynitoApi.post('/contact-us', formData);
            if (res.data.status_code === 200) {
                toastify.success(res.data.message);
                setFormData({
                    name: "",
                    email: "",
                    message: ""
                })
            } else {
                toastify.error(res.data.message);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    }
    return (
        <>
            {/* Compact Hero Section */}
            <section className="modern-contact-hero">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="hero-content">
                                <nav aria-label="breadcrumb" className="modern-breadcrumb mb-3">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/" className="breadcrumb-link">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Contact Us
                                        </li>
                                    </ol>
                                </nav>
                                <h1 className="hero-title mb-2">Get In Touch</h1>
                                <p className="hero-subtitle">We're here to help and answer any question you might have.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Contact Section */}
            <section className="modern-contact-section">
                <div className="container">
                    <div className="row g-4">
                        {/* Contact Information */}
                        <div className="col-lg-5">
                            <div className="contact-info-card">
                                <div className="company-info text-center mb-4">
                                    <h3 className="company-name">Fynito Marketing India Private Limited</h3>
                                    <div className="company-image-wrapper">
                                        <img src={contactimg} alt='Contact Us' className="company-image" />
                                    </div>
                                </div>
                                
                                <div className="contact-methods">
                                    <div className="contact-method">
                                        <div className="contact-icon">
                                            <i className="fas fa-envelope"></i>
                                        </div>
                                        <div className="contact-details">
                                            <h5>Email Support</h5>
                                            <p>24/7 Available</p>
                                            <Link to={`mailto:${commonwebData?.support_email}`} className="contact-link">
                                                {commonwebData?.support_email}
                                            </Link>
                                        </div>
                                            </div>

                                    <div className="contact-method">
                                        <div className="contact-icon whatsapp">
                                            <i className="fab fa-whatsapp"></i>
                                        </div>
                                        <div className="contact-details">
                                            <h5>WhatsApp</h5>
                                            <p>24/7 Available</p>
                                            <Link 
                                                to={`https://wa.me/91${commonwebData?.contact_number}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                className="contact-link"
                                            >
                                                +91-{commonwebData?.contact_number}
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="contact-method">
                                        <div className="contact-icon location">
                                            <i className="fas fa-map-marker-alt"></i>
                                        </div>
                                        <div className="contact-details">
                                            <h5>Our Address</h5>
                                            <p className="address-text">
                                                3rd Ln, opposite Raithu Bazar, behind Kamma Hostel, 
                                                Brindavan Gardens, Guntur, Andhra Pradesh 522006
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className="col-lg-7">
                            <div className="contact-form-card">
                                <div className="form-header">
                                    <h3 className="form-title">Send us a Message</h3>
                                    <p className="form-subtitle">Fill out the form below and we'll get back to you as soon as possible.</p>
                                </div>
                                
                                <form onSubmit={handleSubmit} className="modern-contact-form">
                                    <div className="form-group">
                                        <label htmlFor="name" className="form-label">Full Name</label>
                                        <input 
                                            type="text" 
                                            id="name"
                                            name="name" 
                                            value={formData.name} 
                                            onChange={handleChange} 
                                            className="form-control modern-input" 
                                            placeholder="Enter your full name"
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label htmlFor="email" className="form-label">Email Address</label>
                                        <input 
                                            type="email" 
                                            id="email"
                                            name="email" 
                                            value={formData.email} 
                                            onChange={handleChange} 
                                            className="form-control modern-input" 
                                            placeholder="Enter your email address"
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label htmlFor="message" className="form-label">Message</label>
                                        <textarea 
                                            id="message"
                                            name="message" 
                                            value={formData.message} 
                                            onChange={handleChange} 
                                            className="form-control modern-textarea" 
                                            placeholder="Tell us how we can help you..."
                                            rows="5"
                                            required
                                        ></textarea>
                                    </div>
                                    
                                    <div className="form-group">
                                        <button 
                                            className="modern-submit-btn" 
                                            type="submit" 
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Sending...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-paper-plane me-2"></i>
                                                    Send Message
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mobile Bottom Bar */}
            <MobileBottomBar />
        </>
    )
}

export default ContactUs